import { TextureLoader } from 'three'
import { LHFEventDispatcher } from '../../com/LHFEventDispatcher'
import { HashMap } from '../../ts/core/HashMap'
import { OEEvents } from '../../ts/core/OEEvents'
/**
 * 资源管理
 */
class TextureRes extends LHFEventDispatcher {
  static instance = null
  static getInstace() {
    if (!this.instance) {
      new TextureRes()
    }
    return this.instance
  }
  constructor() {
    super()
    if (TextureRes.instance) {
      throw new Error('贴图资源管理为单例')
    }
    TextureRes.instance = this
    this.init()
    this.map = new HashMap()
    this.resLoad = []
    this.textures = []
  }
  /**
   * 获取一个贴图
   * @param {string} key_
   */
  getTexture(key_) {
    return this.map.get(key_)
  }
  init() {
    this.textureLoader = new TextureLoader()
  }
  /**
   * 加载完成判断
   */
  loadCompleteCheck() {
    if (!this.loadCount) {
      this.dispatchEvent({ type: OEEvents.LOAD_COMPLETE })
    }
  }
  addResItem(item_) {
    this.resLoad.push(item_)
    this.textures.push(item_)
  }
  startLoad() {
    this.loadCount = this.resLoad.length
    this.resLoad.forEach(item_ => {
      let texture = this.textureLoader.load(
        item_.texture,
        textureSus => {
          this.loadItemComplete()
        },
        event => {},
        err => {
          this.loadItemError()
        }
      )
      this.map.put(item_.key, texture)
    })
    // 清除加载队列
    this.resLoad = []
  }
  // 单个加载完成
  loadItemComplete() {
    this.loadCount--
    this.loadCompleteCheck()
  }
  // 单个加载失败
  loadItemError() {
    this.loadCount--
    this.loadCompleteCheck()
  }
}

export { TextureRes }



// WEBPACK FOOTER //
// ./src/webgl/resources/TexturesRes.js